<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Necessidades em Aberto
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-necessidades' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="q-ml-md">
      <section
        style="margin-bottom: -20px"
        class="row col-12 q-mt-md q-gutter-sm text-brand-1 text-weight-bold"
      >
        <div class="col-md">
          <div>Comprado</div>
          <q-select
            :options="filtrosComprados"
            label="Estoque"
            dense
            outlined
            v-model="filtros.compra"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>
        <div class="col-md">
          <div>Com Comprador</div>
          <q-select
            :options="filtrosComprador"
            label="Comprador"
            dense
            outlined
            v-model="filtros.comprador"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md col-xs">
          <div>Data Inicial</div>
          <q-input
            dense
            outlined
            debounce="500"
            placeholder="DD/MM/AAAA"
            v-model="filtros.dataInicial"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-md col-xs">
          <div>Data Final</div>
          <q-input
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.dataFinal"
            mask="##/##/####"
            debounce="500"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </section>
      <section class="row col-12 q-gutter-sm text-brand-1 text-weight-bold">
        <div class="col-md">
          <div class="q-ml-sm">Numero Necessidade:</div>
          <q-input outlined dense v-model="filtros.numeroNecessidade">
          </q-input>
        </div>
        <div class="col-md col-xs">
          <div>Responsável</div>

          <SelectSolicitante
            label="Nome do Responsavel"
            v-model="filtros.responsavel"
          />
        </div>

        <div class="col-md col-xs">
          <div>Produto</div>
          <q-input
            outlined
            debounce="500"
            dense
            v-model="filtros.produto"
            placeholder="Nome do Produto"
          >
          </q-input>
        </div>

        <div class="col-md col-xs">
          <div>Solicitante</div>
          <q-input
            outlined
            debounce="500"
            dense
            v-model="filtros.solicitante"
            placeholder="Nome do Solicitante"
          >
          </q-input>
        </div>
      </section>
      <div class="col-md col-2 q-mt-sm">
        <q-btn
          color="secondary q-mt-sm"
          icon="filter_alt"
          no-caps
          label="Aplicar filtros"
          @click="getDados"
        />
      </div>
    </div>

    <div class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span>Produtos Sem Associação no Catálogo </span>

        <q-btn
          @click="exportar"
          class="q-ml-sm"
          icon="file_upload"
          label="Exportar"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
        />
      </div>
      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rows"
        title-class="text-brand-5 text-weight-bold"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold" :props="props">
            <q-td>
              <router-link
                style="text-decoration: none; color: blue"
                :to="{
                  name: 'compras-detalhe',
                  params: { id: props.row.uuid },
                }"
              >
                <span>{{ props.row.numero }}</span>
              </router-link>
            </q-td>
            <q-td>
              <span>{{
                props.row.created_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
            <q-td>
              <span class="text-brand-5 text-weight-bold">{{
                props.row.solicitante_nome
              }}</span>
            </q-td>
            <q-td>
              <span class="text-brand-5 text-weight-bold">{{
                props.row.responsavel_nome
              }}</span>
            </q-td>
            <q-td>
              <span class="text-brand-5 text-weight-bold">{{
                props.row.produto_nome
              }}</span>
            </q-td>
            <q-td>
              <span class="text-brand-5 text-weight-bold">{{
                formatQuantidade(props.row.quantidade_necessaria)
              }}</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <table-produtos-abertos :atualizar="atualizar" :filtros="filtros" />
  </q-page>
</template>

<script>
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,0000";
  const num = Number(String(value).replace(",", "."));
  if (isNaN(num)) return "0,0000";

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(num);
};

const columns = [
  {
    name: "numero",
    label: "Necessidade #",
    field: "numero",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "created_at",
    label: "Criada em",
    field: "created_at",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "solicitante_nome",
    label: "Solicitante",
    field: "solicitante_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "responsavel_nome",
    label: "Responsável",
    field: "responsavel_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "produto_nome",
    label: "Produto",
    field: "produto_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "quantidade_necessaria",
    label: "Qtd. de Compra",
    field: "quantidade_necessaria",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import TableProdutosAbertos from "../components/TableProdutosAbertos.vue";
import SelectSolicitante from "../components/SelectSolicitante.vue";
export default {
  components: { TableProdutosAbertos, SelectSolicitante },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const filtrar = ref("");
    const filtros = ref({
      dataInicial: "",
      dataFinal: "",
      compra: {
        label: "Todos",
        value: 2,
      },
      responsavel: "",
      produto: "",
      solicitante: "",
      comprador: "",
      numeroNecessidade: "",
    });
    const atualizar = ref(0);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 15) => {
      disable.value = true;
      try {
        const response = await store.dispatch("compras/semAssociaçãoCatalogo", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          produto:
            filtros.value.produto == "" ? undefined : filtros.value.produto,
          responsavel: filtros.value.responsavel.sap,
          user:
            filtros.value.solicitante == ""
              ? undefined
              : filtros.value.solicitante,
          data_inicial: filtros.value.dataInicial,
          data_final: filtros.value.dataFinal,
          comprado: filtros.value.compra?.value,
          com_comprador: filtros.value.comprador?.value,
          numero:
            filtros.value.numeroNecessidade == ""
              ? undefined
              : filtros.value.numeroNecessidade,
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;

        atualizar.value++;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/semAssociaçãoCatalogoExportar", {
          vendor_id: store.state.org.unidadeData.id,
          produto: filtros.value.produto,
          responsavel: filtros.value.responsavel.sap,
          user: filtros.value.solicitante,
          data_inicial: filtros.value.dataInicial,
          data_final: filtros.value.dataFinal,
          comprado: filtros.value.compra?.value,
          com_comprador: filtros.value.comprador?.value,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const gerarDataAtual = () => {
      let hoje = new Date();
      let data15DiasAtras = new Date(hoje);
      data15DiasAtras.setDate(hoje.getDate() - 20);

      let diaAntigo = String(data15DiasAtras.getDate()).padStart(2, "0");
      let mesAntigo = String(data15DiasAtras.getMonth() + 1).padStart(2, "0");
      let anoAntigo = data15DiasAtras.getFullYear();

      let diaAtual = String(hoje.getDate()).padStart(2, "0");
      let mesAtual = String(hoje.getMonth() + 1).padStart(2, "0");
      let anAtual = hoje.getFullYear();

      let dataFormatadaAntiga = diaAntigo + "/" + mesAntigo + "/" + anoAntigo;
      let dataFormatadaAtual = diaAtual + "/" + mesAtual + "/" + anAtual;

      filtros.value.dataInicial = dataFormatadaAntiga;
      filtros.value.dataFinal = dataFormatadaAtual;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    onMounted(() => {
      gerarDataAtual();
      getDados();
    });

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      gerarDataAtual,
      filtros,
      atualizar,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      filtrosComprados: [
        {
          label: "Comprados",
          value: 1,
        },
        {
          label: "Não Comprados",
          value: 0,
        },
        {
          label: "Todos",
          value: 2,
        },
      ],
      filtrosComprador: [
        {
          label: "Comprador Definido",
          value: 1,
        },
        {
          label: "Comprador não Definido",
          value: 0,
        },
        {
          label: "Todos",
          value: undefined,
        },
      ],
      exportar,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      formatQuantidade,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
theader tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap !important;
}

a {
  text-decoration: none;
}
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
